import React, { useContext, useState } from "react";
import { PopupContext, TableContext } from "../../index";
import { CardTypes } from "../UserCardService";
import { showSuccessToast } from "../../validation/ToastContainer";
import { deleteAuthServer } from "../authService";
import { getDeletePopup } from "../../view/popup/PopupContainer";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { MoreVertical, Edit2, Trash2 } from 'lucide-react';

function AuthServerTableRow({ data, index }) {

    const { config, setConfig } = useContext(TableContext);
    const { setPopup } = useContext(PopupContext);

    const getCircleType = () => {
        switch (data.status) {
            case '1':
                return "success";
            case '0':
                return "danger";
            default:
                return "warning";
        }
    }

    // MUI Menu state
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const onEditClick = () => {
        handleClose();
        config.showModal({ cardType: CardTypes.EDIT, authServerId: data.id });
    };

    const onDeleteClick = () => {
        handleClose();

        setPopup(getDeletePopup(`Are you sure you want to delete the ${data.ip} ?`, "Delete Authentication Server", () => {
            deleteAuthServer(data.id).then(() => {
                showSuccessToast("Authentication Server deleted", "Delete Authentication Server");
                setConfig({ ...config, lastUpdated: Date.now() });
            })
        }, undefined, "Delete Server"));

    };

    return (
        <tr key={index}>
            <td>{data.ip}</td>
            <td>{data.baseDN}</td>
            <td>{data.serviceName}</td>
            <td>{data.type}</td>
            <td><div className="oct_status">
                <span className={`oct_circle oct_bg-${getCircleType()}`} />
                {data.status === '1' ? 'connected' : 'disconnected'}
            </div></td>
            <td>
                <button className="oct_dropdown-trigger-v2" onClick={handleClick}>
                    <MoreVertical className="oct_icon" />
                </button>

                <Menu
                    className="oct_menu-v2"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}>

                    <MenuItem className="oct_menu-item-v2" onClick={onEditClick}>
                        <Edit2 className="oct_icon" /> Edit
                    </MenuItem>
                    <MenuItem className="oct_menu-item-v2 oct_menu-item-danger" onClick={onDeleteClick}>
                        <Trash2 className="oct_icon" /> Delete
                    </MenuItem>

                </Menu>
            </td>
        </tr>
    );

}

export default AuthServerTableRow;
